import { ActionTree } from 'vuex';
import { EGoogleDriveError } from '../google-drive/types/google-drive-error';
import { ICreatePageDTO } from '@/api/documents/dtos/create-page-dto';
import { DocumentService } from '@/api/documents/services/document.service';
import {
  ECreatePageAction,
  ECreatePageMutation,
  state as defaultState,
} from '@/document-manipulator/create-page/store/create-page.constants';
import { ICreatePageState } from '@/document-manipulator/create-page/store/create-page.types';
import { translate } from '@/helpers/translation.helper';
import { RootState } from '@/store/store';
import { IDocumentPage } from '@lib-shared/types/document-page';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';

export const actions: ActionTree<ICreatePageState, RootState> = {
  [ECreatePageAction.Reset]({ commit }) {
    commit(ECreatePageMutation.SetState, { ...defaultState });
  },
  async [ECreatePageAction.Create](
    { commit, dispatch },
    { payload, resourceId }: { payload: ICreatePageDTO; resourceId: string }
  ) {
    commit(ECreatePageMutation.SetCreating, true);
    try {
      const page: IDocumentPage = await DocumentService.createPage(payload);
      dispatch(ECreatePageAction.CreateSuccess, { ...page, resourceId });
    } catch {
      dispatch(ECreatePageAction.CreateFailed);
    }
  },
  [ECreatePageAction.CreateSuccess]({ commit }, page: IDocumentPage) {
    commit(ECreatePageMutation.SetCreatedPage, page);
    commit(ECreatePageMutation.SetCreating, false);
  },
  [ECreatePageAction.CreateFailed]({ commit, dispatch }) {
    commit(ECreatePageMutation.SetCreatedPage, { ...defaultState }.createdPage);
    commit(ECreatePageMutation.SetCreating, false);
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-create-page'), {
      root: true,
    });
  },
  [ECreatePageAction.EvaluateGoogleDriveError]({ dispatch }, error: EGoogleDriveError) {
    let message: string;
    switch (error) {
      case EGoogleDriveError.Authenticate:
        message = 'failed-to-authenticate';
        break;
      case EGoogleDriveError.Fetch:
        message = 'failed-to-fetch-data-from-google-drive';
        break;
      case EGoogleDriveError.Import:
        message = 'failed-to-import-google-drive-document';
        break;
      default:
        message = 'error-with-google-drive-integration';
    }
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate(message).toString(), {
      root: true,
    });
  },
};
